import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select, TextField } from "ui";
import { MenuItem } from "@mui/material";
import DatatransModel from "./types/DatatransModel";
import FormRef from "../types/FormRef";

type DatatransFormProps = {
    errors: any;
    loading: boolean;
    onSubmit: (data: DatatransModel) => void;
};

const DatatransForm = forwardRef<FormRef, DatatransFormProps>(
    ({ errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={{}}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                    merchant_id: { default: "" },
                    password: { default: "" },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                                <SettingsItem label="Merchant ID">
                                    <TextField
                                        fullWidth
                                        id="merchant_id"
                                        margin="none"
                                    />
                                </SettingsItem>
                                <SettingsItem label="Password">
                                    <TextField
                                        fullWidth
                                        id="password"
                                        margin="none"
                                    />
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default DatatransForm;
